// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { Button, FormControl, Grid, IconButton, InputAdornment, InputLabel, Menu, MenuItem, Select, TextField, Toolbar, Tooltip } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '../components/TimePicker';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import * as React from 'react';

import { CREATE, DataAPIContext } from '../api';
import UploadDocumentButton from '../components/UploadDocumentButton';
import { debounce } from '../utils';
import { originMenuItems, ORIGINS, statusMenuItems } from './utils';

export const ImportListToolbar = (props: any) => {
    const dataAPI = React.useContext(DataAPIContext);
    const resource = props.resource;
    const { enqueueSnackbar } = useSnackbar();
    const searchQueryRef = React.useRef(null);
    const [statuses, setStatuses] = React.useState([]);
    const [origins, setOrigins] = React.useState(Object.keys(ORIGINS));
    const [fromDate, setFromDate] = React.useState(null);
    const [toDate, setToDate] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    // const client_timezone = new Date().toString().match(/\(([A-Za-z\s].*)\)/)[1]
    
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onFileSelect = async (file: any) => {
        handleSave(file);
    };

    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);

    const onFromDateChange = (ts) => {
        setFromDate(ts);
        props.onApiFilterChange({ field: 'from_date', value: moment.utc(ts).toISOString() });
        if (ts && toDate && moment(ts).isAfter(toDate)) {
            enqueueSnackbar('From Date cannot be after To date', { variant: 'error' });
        }
    };

    const onToDateChange = (ts) => {
        setToDate(ts);
        props.onApiFilterChange({ field: 'to_date', value: moment.utc(ts).toISOString() });
        if (ts && fromDate && moment(ts).isBefore(fromDate)) {
            enqueueSnackbar('To Date cannot be before From Date', { variant: 'error' });
        }
    };

    const onStatusChange = (ev) => {
        // if(ev.target.value.length === 0) {
        //     setStatuses(Object.keys(STATUSES));
        //     props.onApiFilterChange({ field: 'status', value: Object.keys(STATUSES) });
        //     return; 

        // }
        setStatuses(ev.target.value);
        props.onApiFilterChange({ field: 'status', value: ev.target.value });
    };  
   

    const onOriginChange = (ev) => {
        if(ev.target.value.length === 0) {
            setOrigins(Object.keys(ORIGINS));
            props.onApiFilterChange({ field: 'origin', value: Object.keys(ORIGINS) });
            return; 
        }
        setOrigins(ev.target.value);
        props.onApiFilterChange({ field: 'origin', value: ev.target.value });
    };

    const handleSave = (file: any) => {
        props.setRelatedLoading(true);
        (async () => {
            try {
                console.log('upload', file);
                const res = await dataAPI(CREATE, resource, { data: { file }, upload: true });
                if (res.statusCode === 201) {
                    enqueueSnackbar(`${res.data?.converted ? "JSON" : "XML"} file queued to be processed with ID ${res.data?.id}`, { variant: 'success' });
                    props.setLastUpdate(new Date().toString());
                } else if (res.statusCode === 406) {
                    enqueueSnackbar('Import error', { variant: 'error' });
                    props.setLastUpdate(new Date().toString());
                } else {
                    enqueueSnackbar(res.data?.message || `Something went wrong please try again (${res.statusCode})`, { variant: 'error' });
                    props.setLastUpdate(new Date().toString());
                }
            } finally {
                props.setRelatedLoading(false);
            }
        })();
    };

    const isDateRangeInvalid = !!(toDate && fromDate && moment(toDate).isBefore(fromDate));

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Toolbar disableGutters={true} sx={{ justifyContent: 'space-between', minHeight: 0 }}>
                <Grid container direction="row" spacing={2} alignItems="flex-start">
                        <Grid item  xs={12} sm={3} lg={4}>
                            <TextField
                                variant="filled"
                                // label="Search"
                                size="small"
                                onChange={debouncedSearchQueryChangeHandler}
                                inputRef={searchQueryRef}
                                fullWidth
                                placeholder="Search by import ID, email, tour name..."
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Search">
                                                <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                                    <SearchIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    {/* </Grid> */}
                    <Grid item xs={12} sm={3} container direction="row" spacing={2}>
                        <Grid item xs={6}>
                            <FormControl fullWidth variant="filled" size="small">
                                <InputLabel id="override_mode">Status</InputLabel>
                                <Select name="status" labelId="status" id="status" value={statuses.length === statusMenuItems.length ? [] : statuses} onChange={onStatusChange} multiple>
                                    {statusMenuItems}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth variant="filled" size="small">
                                <InputLabel id="override_mode">Origin</InputLabel>
                                <Select name="status" labelId="origin" id="origin" value={origins.length === originMenuItems.length ? [] : origins}  onChange={onOriginChange} multiple>
                                    {originMenuItems}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3} container direction="row" spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={6}>
                            <DateTimePicker
                                slotProps={{
                                    textField: {
                                        variant: 'filled',
                                        size: 'small',
                                        fullWidth: true,
                                        helperText: isDateRangeInvalid ? 'Should be earlier than To Date' : 'Enter date time in UTC',
                                        error: isDateRangeInvalid,
                                    },
                                    actionBar: {
                                        actions: ['clear', 'accept'],
                                    },
                                }}
                                label="From (UTC)"
                                value={fromDate}
                                maxDateTime={toDate || undefined}
                                onChange={onFromDateChange}
                                disableFuture
                                timezone={'UTC'}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <DateTimePicker
                                slotProps={{
                                    textField: {
                                        variant: 'filled',
                                        size: 'small',
                                        fullWidth: true,
                                        helperText: isDateRangeInvalid ? "Should be later than From Date" : 'Enter date time in UTC',
                                        error: isDateRangeInvalid,
                                    },
                                    actionBar: {
                                        actions: ['clear', 'accept'],
                                    },
                                }}
                                label="To (UTC)"
                                value={toDate}
                                minDateTime={fromDate || undefined}
                                onChange={onToDateChange}
                                disableFuture
                                timezone={'UTC'}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3} lg={2} container direction="row" justifyContent="flex-end" alignItems="center">
                        {!props.selection || props.selection.length <= 0 ? (
                            <UploadDocumentButton onSelect={onFileSelect} accept=".xml, .json" size="small" helperText={''} customLabel={'Upload XML or JSON file'} />
                        ) : (
                            <>
                                <Button
                                    // style={{ position: 'fixed', top: '0.75rem', right: 20 }}
                                    id="basic-button"
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                    color="primary"
                                    variant="contained"
                                    disabled={props.syncActive}>
                                    <MenuIcon />
                                    &nbsp; Actions
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}>
                                    <MenuItem
                                        onClick={() => {
                                            props.onReimportSelection();
                                            setAnchorEl(null);
                                        }}>
                                        Reimport
                                    </MenuItem>
                                </Menu>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Toolbar>
        </LocalizationProvider>
    );
};

export default ImportListToolbar;
